import React, { useState, useEffect } from 'react'
import { Form, Layout } from "antd";
import "antd/dist/antd.css"
import { ToastContainer } from "react-toastify";
import Loading from "../../commons/components/loading";
import "../../commons/templates/custom.css";
import 'react-toastify/dist/ReactToastify.css';
import Header from "../../commons/components/headerPublic";
import Footer from "../../commons/components/footer"
import Http from '../../commons/utils/Http'
import jwt from "jsonwebtoken";
import AvatarLockedIcon from "../../commons/icons/avatarLockedIcon"

const { Content } = Layout;

export default () => {

    const states = {
        UNLOCK_USER: 1,
        ERROR: 2,
        SUCCESS: 3,
        LOADING: 4
    };

    const [appState, setAppState] = useState();
    const [token, setToken] = useState("");
    const [msgError, setMsgError] = useState("");

    useEffect(() => {
        getUserDataFromToken()
    }, []);

    const getUserDataFromToken = () => {
        localStorage.clear();
        const url = window.location.href;
        const parametrosDaUrl = url.split("?")[1];
        if (parametrosDaUrl) {
            const listaDeParametros = parametrosDaUrl.split("&")
            const parameters = {}
            for (var i = 0; i < listaDeParametros.length; i++) {
                var parametro = listaDeParametros[i].split("=");
                var chave = parametro[0];
                var valor = parametro[1];
                parameters[chave] = valor;
            }
            const token = parameters["token"]
            Http.post("/validate-session", { token: token })
                .then(resp => {
                    setToken(token);
                    const tokenData = jwt.decode(token);
                    if (tokenData) {
                        localStorage.setItem("token", token);
                        setAppState(states.UNLOCK_USER);
                    }

                }).catch(err => {
                    setMsgError('Este link não é válido, por favor contate o administrador')
                    setAppState(states.ERROR);
                })
        } else {
            setMsgError('Este link não é válido, por favor contate o administrador')
            setAppState(states.ERROR);
        }
    }

    const renderData = () => {
        switch (appState) {
            case states.ERROR:
                return error();
            case states.LOADING:
                return loading();
            case states.UNLOCK_USER:
                return unlockUser();
            case states.SUCCESS:
                return success();
            default:
                return loading();
        }
    }

    const success = () => {
        redirect();

        return (
            <div style={{ paddingBottom: 14 }} className="content-text">
                <div className="info-link">Você será redirecionado...</div>
            </div>
        )
    };

    const loading = () => {
        return (
            <div className="loading-template" style={{ minHeight: 50, paddingBottom: 30 }}>
                <Loading height={50} width={50} />
            </div>
        )
    };

    const error = () => {
        redirect();

        return (
            <div style={{ paddingBottom: 14 }} className="content-text">
                <div className="error-out">
                    <div className="span-display-block span-display-error">
                        {msgError}
                    </div>
                </div>
                <div className="info-link">Você será redirecionado...</div>
            </div>
        )
    };

    const redirect = () => {
        localStorage.clear();
        setTimeout(function () {
            window.location.href = process.env.REACT_APP_LOGIN_WEB;
        }, 5000);
    }

    const unlockUser = () => {
        Http.get(`/unlock-user?token=${token}`).then(resp => {
            setAppState(states.SUCCESS);
            success();
        }).catch(err => {
            const error = err.response.data.response;
            if (error.status == 417) {
                setMsgError(error.message);
            } else {
                setMsgError('Error ao tentar desbloquear sua conta, por favor contate o administrador')
            }
            setAppState(states.ERROR);
        });
    }

    const renderHeader = () => {
        return (
            <>
                <div className="container-avatar">
                    <AvatarLockedIcon className="avatar-svg" />
                </div>
                <div className="header-text">Sua conta está sendo desbloqueada!</div>
            </>
        )
    }

    return (
        <Layout className="layout" style={{ minHeight: "100vh", width: "100%" }}>
            <Header />
            <Content>
                <div className="main-container">
                    {renderHeader()}
                    {renderData()}
                    <ToastContainer position="bottom-right" />
                </div>
                <Footer />
            </Content>
        </Layout>
    )
}